import { onChange, highlightErrors } from '../../actions/login';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { Reducer } from '../../reducers';
import { Dispatch } from 'redux';
const { TextField } = window.Edocat.Components;
const { Visibility, VisibilityOff } = window.MaterialIcons;
const { IconButton } = window.Material;

interface InputDrilledProps {
  autoFocus: boolean;
  label: string;
  type: string;
  name: string;
  autoComplete?: string;
}

interface InputProps extends InputDrilledProps, ReduxComponentInterface {
  value: string;
  error: string;
  globalError: string;
}

interface InputState {
  showPassword: boolean;
}

class Input extends React.PureComponent<InputProps, InputState> {
  private readonly input: React.RefObject<any>;

  constructor(props: InputProps) {
    super(props);

    this.state = {
      showPassword: false,
    };

    this.input = React.createRef();
  }

  onChange = (event: React.ChangeEvent) => {
    event.preventDefault();
    const { actions, name } = this.props;
    const value = (event.target as HTMLInputElement).value;
    actions.onChange(name, value);
  };

  render() {
    const { label, name, type, value, error, autoFocus, autoComplete } = this.props;
    const { showPassword } = this.state;

    return (
      <div className="Form-Row">
        <TextField
          autoComplete={autoComplete}
          value={value}
          type={showPassword ? 'text' : type}
          onChange={this.onChange}
          name={name}
          id={name}
          label={label}
          error={error}
          helperText={error && window.Edocat.texts['label.mandatory']}
          autoFocus={autoFocus}
          endAdornment={
            type === 'password' ? (
                <IconButton edge="end" onClick={() => this.setState(state => ({ showPassword: !state.showPassword }))}>
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
            ) : null
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state: Reducer, props: InputDrilledProps) => ({
  value: state.login.form[props.name],
  error: state.login.errors[props.name],
  globalError: state.login.error,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: window.redux.bindActionCreators({ onChange, highlightErrors }, dispatch),
});

export default window.reactRedux.connect(mapStateToProps, mapDispatchToProps)(Input);
